import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { TestModel } from 'src/app/models/testModel';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { TestConstant } from 'src/app/constants/label-constants';
import { CommonConstant, DateFormate, NoRecordFound } from 'src/app/constants/common-constant';
import { Router } from '@angular/router';
import { DeleteDialogboxComponent } from '../delete-dialogbox/delete-dialogbox.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { TestDetailComponent } from './test-detail/test-detail.component';
import { ThemePalette } from '@angular/material/core';
import { TestDialogComponent } from '../test-dialog/test-dialog.component';
import { RestartExamComponent } from '../restart-exam-dialogbox/restart-exam/restart-exam.component';
@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent {
  TestList: any = [];
  currentDateTime = new Date();
  closeResult = '';
  enterSearch: string = '';
  searchClose: boolean = false;
  SortColumn: any = '';
  sortDirection: any = '';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  showData: boolean = false;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = ['rowNumber', 'examName', 'date', 'examTime', 'durationInMins', 'noOfStudent', 'attemptedStudent', 'Live/Result', 'Action'];
  dataSource: MatTableDataSource<TestModel> = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  isSubmitted: boolean = false;
  navigateFlag: boolean = false;
  submitted: boolean = false;
  isTestLive: boolean = false;
  dateConstant: any = [];
  TestConstant: any = [];
  CommonConstant: any = [];
  NoRecordFound: any = [];
  testDeleteObj: any = {};
  color: ThemePalette = 'accent';
  checked: boolean = false;
  disabled = false;
  testObj: any = {};

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  constructor(
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private sharedService: SharedService,
    private router: Router,
    private modalService: NgbModal,
    private EncrDecr: EncrDecrService,
  ) { }

  ngOnInit(): void {
    this.dateConstant = DateFormate;
    this.TestConstant = TestConstant;
    this.CommonConstant = CommonConstant;
    this.NoRecordFound = NoRecordFound;
    this.getTestList();
    this.sharedService.setData('Exam');
  }

  getTestList() {
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.test.GetTestList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.spinner.hide();
          this.showData = true;
          let TotalRecords = 0;
          this.TestList = response.data
          this.dataSource.data = this.TestList;
          if (this.TestList.length > 0) {
            TotalRecords = this.TestList[0].totalRecords;
            this.totalRows = TotalRecords;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        }
        else {
          this.spinner.hide();
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }

  pageChanged(event: { pageSize: number; pageIndex: number; }) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getTestList();
  }

  SortChange(event: { direction: string; active: any; }) {
    this.sortDirection = event.direction == '' ? 'asc' : event.direction;
    this.SortColumn = event.active;
    this.getTestList();
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage =0;
      this.getTestList();
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.enterSearch = event.target.value;
      this.getTestList();
      this.searchClose = true;
    }
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getTestList();
    this.searchClose = false;
  }

  sanitizeInput(event: any) {
    const inputElement: HTMLInputElement = event.target;
    const sanitizedValue: string = inputElement.value.replace(/\D/g, '');
    inputElement.value = sanitizedValue;
  }

  Add() {
    this.router.navigate(['/exam/add']);
  }

  timeConvert(n: number) {
    var hours = (n / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    if (rhours == 0) {
      return rminutes + " min"
    }
    else if (minutes == 0) {
      return rhours + " hr";
    }
    else {
      return rhours + " hr : " + rminutes + " min";
    }
  }

  viewResult(testId: number, element: any) {
    if(element.attemptedStudent > 0){
      var encrypted = this.EncrDecr.set('123456$#@$^@1ERF', testId);
      this.router.navigate(['exam/studentlist/', encrypted]);
    }
    else{
      this.toastr.error("No result was found because an attempted student is 0.");
    }
  }

  TestDetail(testId: number) {
    const modalRef = this.modalService.open(TestDetailComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.testId = testId;
  }

  changed(event: any, testId: number) {
    // event.target.value;
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.test.LiveTest.replace("{id}", testId.toString());
    this.commonService.doGet(apiUrl).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.spinner.hide();
          this.toastr.success(response.message);
        }
        else {
          this.spinner.hide();
          this.toastr.error(response.message);
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.toastr.error(error.message);
      }
    });
  }

  restartTest() {
    const modalRef = this.modalService.open(RestartExamComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.result.then((result) => {
    }).catch((error) => {
    });
  }

  liveTest(testId: number, testName: string, isLive: boolean, endTime: any, event: any) {
    if(this.getDate(endTime) < this.currentDateTime){   
      this.toastr.error("Exam has been completed, you can't exam live or hold.");
      this.getTestList();
      return;
    }
    const modalRef = this.modalService.open(TestDialogComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.testObj = {
      testId: testId,
      testName: testName,
      element: 'Exam Live/Hold',
      status: isLive
    }

    modalRef.componentInstance.testObj = this.testObj;
    modalRef.result.then((result) => {
      if (result === 'confirm') {
        this.isTestLive = true;
        const apiUrl = this.apiUrl.apiUrl.test.LiveTest.replace("{id}", testId.toString());
        this.commonService.doGet(apiUrl).pipe().subscribe({
          next: async (response) => {
            this.spinner.hide();
            if (response.success) {
              this.spinner.hide();
              this.toastr.success(response.message);
              this.getTestList();
            }
            else {
              this.spinner.hide();
              this.toastr.error(response.message);
              this.getTestList();
            }
          },
          error: (error) => {
            this.spinner.hide();
            this.toastr.error(error.message);
          }
        });
      }
      else if (result === 'cancel') {
        this.getTestList();
      }
    }).catch((error) => {
    });
  }

  Deletepopup(testId: number, testName: string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.testDeleteObj = {
      testId: testId,
      testName: testName,
      element: 'exam'
    }
    modalRef.componentInstance.testDeleteObj = this.testDeleteObj;
    modalRef.result.then((result) => {
      if (result === 'delete') {
        this.getTestList();
        this.spinner.hide();
      }
    }).catch((error) => {
    });
  }

  RedirectToEdit(Testid:any){
    if (Testid > 0) {
      var encrypted = encodeURIComponent(this.EncrDecr.set('123456$#@$^@1ERF', Testid));
      // this.router.navigate(['question/edit', questionTypeText.replace(' ', '').toLowerCase(), encrypted]);
      this.router.navigate([`exam/edit/${encrypted}`])
    }
    else {
      this.router.navigate(['exam/add'])
    }
    // this.router.navigate([`exam/edit/${Testid}`])
  }

  getDate(passDate) {
    return new Date(passDate)
  }
}


